
const baseURL = window.baseURL;


let getImgUrl = function(img){
	if(img){
		return require('../assets/'+img)
	}else{
		return '';
	}
}



const NeWDomain = {
	baseURL,
	getImgUrl:getImgUrl
}


export default {
    install(Vue, options){
        Vue.prototype.$NeWDomain = NeWDomain;

    }
}